<template>
    <div class="body">
        <van-row v-for="item in dataList" :key="item.id">
            <van-col :span="19">
                <div class="content">
                    <div class="congten-img">
                        <img :src="item.imgs" alt="">
                    </div>
                    <div class="title">
                        <div class="f-title">{{item.pkgName}}</div>
                        <div class="f-title-s">生效时间:  {{item.startTime}}</div>
                        <div class="f-title-s">{{item.create_time}}</div>
                         <div class="f-title-s">兑换单号:{{item.remark}}</div>
                    </div>
                </div>
            </van-col>
            <van-col :span="5">
                <div class="exchange" v-if="item.state === 0"  @click="toBuyPkg()">{{item.stateName}}</div>
                <div class="y-exchange" v-else>{{item.stateName}}</div>
            </van-col>
        </van-row>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default {
    data(){
        return{
            dataList:[]
        }
    },
    created(){
        this.init()
    },
    methods:{
        toBuyPkg(){
             this.$router.push({
                    path: "/user/recharge",
                    query: {
                      iccid: this.$store.state.iccid,
                    },
                  });
        },
        init(){
            var params = {
                iccid:this.$store.state.iccid
            }
            wxRequest('/applyChangeSim/show/salePrice',params, 'post').then(res => {
                if(res.data.code == 200){
                    this.dataList = res.data.data
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        exchange(data){
            var params = {
                id:data.id
            }
            wxRequest('/applyChangeSim/show/to/apply',params, 'post').then(res => {
                if(res.data.code == 200){
                      Dialog.alert({title: "提示", message: '兑换成功'});
                    this.init()
                }else {
                    Toast.fail(res.data.message);
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .body{
        .van-row{
            margin:13px;
            border-bottom:1px solid #FAFAFA;
            padding-bottom:16px;
            .content{
                display: flex;
                align-items: center;
               .congten-img{
                    width: 50px;
                    height:50px;
                    text-align: center;
                    background: #FFF2FF;
                    border-radius:100%;
                    line-height:50px;
                    margin-right: 10px;
                    img{
                        width:30px;
                        vertical-align: middle;
                    }
               } 
               .title{
                .f-title{
                    font-size:15px;
                    font-weight: 500;
                    margin-bottom:4px;
                }
                .f-title-s{
                    color: #999999;
                    font-size:12px;
                    margin-top:8px;
                }
               }
            }
            .van-col--5{
                padding-top: 12px;
            }
            .exchange{
                height:30px;
                width:66px;
                font-size: 14px;
                color:#FFF;
                line-height:30px;
                text-align: center;
                cursor: pointer;
                border-radius:15px;
                background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
                background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
                background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
                background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
            }
            .y-exchange{
                height:30px;
                width:80px;
                font-size: 14px;
                color:#FFF;
                line-height:30px;
                text-align: center;
                border-radius:15px;
                background: #D8D8D8;
            }
        }
    }
</style>